var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-modal',{staticClass:"basic"},[_c('div',{staticClass:"ui icon header"},[_c('i',{staticClass:"cloud upload icon"}),_vm._v(" Importing ")]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"ui active centered inline loader"})])])}
var staticRenderFns = []

export { render, staticRenderFns }